<div class="daily-report-card">
  <div class="report-header">
    <div class="report-title-row">
      <mat-icon>bar_chart</mat-icon>
      <span class="report-title">{{ 'chatbot.daily_report.title' | translate }}</span>
      @if (reportDate()) {
        <span class="report-date">{{ reportDate() | date: 'mediumDate' }}</span>
      }
    </div>
    <button
      class="dismiss-btn"
      (click)="dismissed.emit()"
      [attr.aria-label]="'chatbot.daily_report.dismiss' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (report()) {
    <div class="report-message">
      <markdown [data]="report().message"></markdown>
    </div>

    <div class="report-footer">
      <button
        mat-stroked-button
        class="view-full-btn"
        [disabled]="isOpeningReport()"
        (click)="openReport()"
      >
        <mat-icon>open_in_new</mat-icon>
        {{ 'chatbot.daily_report.view_full' | translate }}
      </button>
    </div>
  } @else {
    <div class="report-message">
      {{ 'chatbot.daily_report.zip_subtitle' | translate }}
    </div>

    <div class="report-footer">
      <button
        mat-stroked-button
        class="view-full-btn"
        (click)="downloadZip()"
      >
        <mat-icon>download</mat-icon>
        {{ 'chatbot.daily_report.download_zip' | translate }}
      </button>
    </div>
  }
</div>
